import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TemplateService } from 'src/app/core/services/template.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrl: './templates.component.scss'
})
export class TemplatesComponent {
  loading = false;
  error = '';
  successMessage = '';
  templates: any[] = [];
  isAddDocument: boolean = false;


  constructor(
    private templateService: TemplateService,
    private toastService: ToastService,
    private router: Router,
    private confirmModalService: ConfirmModalService

  ) { }

  ngOnInit() {
    this.getTemplates();
  }

  getTemplates() {
    this.loading = true;
    this.templateService.getAllTemplates().subscribe((res: any) => {
      this.templates = res;
      this.loading = false;
    },
      () => {
        this.loading = false;
      });
  }

  addTemplate = () => {
    this.isAddDocument = true;
  }

  back(event: any) {
    this.isAddDocument = false;
    this.selectedTemplate = {};
    if (event?.addTemp) this.getTemplates();
  }

  isViewMode = false;
  selectedTemplate: any = {};
  documentData: any = {};

  templateAction(template: any, action: string) {
    switch (action) {
      case 'view':
        this.isViewMode = true;
        if (template.fileUrl) {
          this.documentData = {
            title: template.name,
            description: template.description,
            pdfUrl: template.fileUrl,
            allSignersPositions: template.allSignersPositions
          }

        }
        break;

      case 'download':
        if (!template?.fileUrl) {
          this.toastService.showToaster('Error', 'No file available to download.', 'error');
          return;
        }

        this.downloadTemplateFile(template);
        break;

      case 'edit':
        this.isAddDocument = true;
        this.selectedTemplate = template;
        break;

      case 'delete':
        this.confirmModalService.open(
          'Delete Template',
          'Are you sure you want to delete this template?',
          () => {
            this.deleteTemplate(template);
          },
          'Delete',
          'Cancel'
        );
        break;
    }

  }

  downloadTemplateFile(template: any) {
    fetch(template.fileUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch file');
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = template.name ? `${template.name}.pdf` : 'template.pdf';
        link.click();
        URL.revokeObjectURL(blobUrl);
      })
      .catch(() => {
        this.toastService.showToaster('Error', 'Failed to download the file.', 'error');
      });
  }
  //   editTemplate(template: any) {
  //   this.isAddDocument = true;
  //   this.selectedTemplate = template;
  // }
  deleteTemplate(template: any) {
    this.loading = true;

    this.templateService.deleteTemplate(template?._id).subscribe(
      (res: any) => {
        this.loading = false;
        this.getTemplates();

        this.toastService.showToaster(
          'Deleted Template',
          res?.message || 'Template successfully deleted.',
          'success'
        );
      },
      () => {
        this.loading = false;
      }
    );
  }

  backView() {
    this.isViewMode = false;
  }
}
